<template>
  <div class="container">
    <el-button size="mini" class="back-box" @click="$router.go(-1)">返回</el-button>
    <div class="table-one" v-if="detail.delList&&detail.delList.length">
      <p class="title">减保记录</p>
      <el-table border :data="detail.delList" class="list-table" tooltip-effect="dark" v-loading="listLoading">
        <el-table-column min-width="160px;" label="创建日期" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column property="bussninessNo" min-width="160px;" label="批单号"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="bussinessInfo" min-width="160px;" label="批改内容"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column min-width="160px;" label="批改保费" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.fee }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <p class="title">待开票记录</p>
    <p class="title"><span>
        1. 已完成付款并生效的保单或批单，可以进行在线申请发票的操作。 2. 保单项下全部未申请开票的批单必须一次性提交开票。 3. 当待开票金额大于0时，方可提交开票申请。 4.
        发票状态为“已申请”表示已完成发票开票申请，可以联系相关服务人员确认发票寄送进度。 5. 实际开票金额，如有细微偏差，请以保司为准
      </span></p>
    <el-table border :data="detail.waitInvoiceRecordVos" class="list-table" tooltip-effect="dark" v-loading="listLoading">
      <el-table-column min-width="160px;" label="创建日期" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column property="bussiness" min-width="160px;" label="业务类型"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="bussninessNo" min-width="160px;" label="单号"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="bussinessInfo" min-width="160px;" label="业务内容"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column min-width="160px;" label="保费" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.fee }}</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="total-box">
      <span>开票金额 <b>{{ detail.amount }}</b> 元</span>
      <el-button @click="getInvoice" type="primary" size="mini">提交开票申请</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listLoading: false,
      detail: {},
    }
  },

  created() {
    this.getList();
  },

  methods: {
    getList() {
      this.listLoading = true;
      this.$http({
        url: `/master/group/invoiceRecord/waitApplyList`,
        type: "GET",
        params: {
          policyNo: this.$route.query.policyNo
        }
      }).then((res) => {
        this.detail = res.data;
        this.listLoading = false;
      })
    },

    getInvoice() {
      this.listLoading = true;
      this.$http({
        url: `/master/group/invoice`,
        type: "GET",
        params: {
          policyNo: this.$route.query.policyNo
        }
      }).then((res) => {
        localStorage.setItem('isApplyBack', '4');
        this.listLoading = false;
        if (res.httpCode == 200) {
          this.$message({
            message: '申请成功',
            type: 'success'
          });
        }
        setTimeout(() => {          
          this.$router.go(-1);
        }, 2000);
      }).catch(() => {
        this.listLoading = false;
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  background: #fff;
  padding:10px 20px;
  position: relative;
  .table-one {
    margin-bottom: 50px;
  }
  .back-box {
    position: absolute;
    right: 20px;
  }
}
.title {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 15px;
}

.tools-box {
  display: flex;
  justify-content: flex-end;
}

.total-box {
  font-size: 16px;
  margin-top: 20px;
  span {
    margin-right: 10px;

    b {
      font-weight: 400;
      margin-left: 4px;
    }
  }
}
</style>